<template>
  <div v-if="validToken">
    <h1 class="display-4">{{ $t('ALUMNI_CCID_TITLE') }}</h1>
    <p>{{ $t('ALUMNI_CCID_DESCRIPTION') }}</p>
    <div v-if="responseMessage" v-html="responseMessage" class="alert" v-bind:class="{'alert-danger':hasError,'alert-success':!hasError}" role="alert"></div>
    <form @submit.prevent="submit()" class="d-flex flex-column">
      <ValidatedTextField ref="full_name" name="full_name" :title="$t('LABEL_FULL_NAME')" v-model="full_name" hideCheckmark :label-col=12 />
      <label class="col-12 control-label strong" for="date_of_birth">{{$t('LABEL_DATE_OF_BIRTH')}}</label>
      <input type="date" ref="date_of_birth" name="date_of_birth" :title="$t('LABEL_DATE_OF_BIRTH')" v-model="date_of_birth"/>
      <ValidatedTextField ref="current_phone" name="current_phone" :title="$t('LABEL_CURRENT_PHONE')" v-model="current_phone" :validations="['sms']" hideCheckmark :label-col=12 />
      <ValidatedTextField ref="degrees" name="degrees" :title="$t('LABEL_DEGREES')" v-model="degrees" hideCheckmark :label-col=12 />
      <ValidatedTextField ref="previous_id" name="previous_id" :title="$t('LABEL_PREVIOUS_ID_NUMBER')" v-model="previous_id" :validations="['digits']" hideCheckmark optional :label-col=12 />
      <ValidatedTextField ref="previous_legal_names" name="previous_legal_names" :title="$t('LABEL_PREVIOUS_LEGAL_NAMES')" v-model="previous_legal_names" hideCheckmark optional :label-col=12 />
      <ValidatedTextField ref="previous_phones" name="previous_phones" :title="$t('LABEL_PREVIOUS_PHONES')" v-model="previous_phones" hideCheckmark optional :label-col=12 />
      <ValidatedTextField ref="previous_emails" name="previous_emails" :title="$t('LABEL_PREVIOUS_EMAILS')" v-model="previous_emails" hideCheckmark optional :label-col=12 />
      <ValidatedTextField ref="previous_addresses" name="previous_addresses" :title="$t('LABEL_PREVIOUS_ADDRESSES')" v-model="previous_addresses" hideCheckmark optional :label-col=12 />
      <button class="btn btn-primary align-self-end" ref="submit" name="submit" type="submit">{{ $t('BUTTON_SUBMIT') }}</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import ValidatedTextField from './ValidatedTextField.vue';
import {responseMessage} from '../mixins/responseMessage';

export default {
  mixins: [responseMessage],
  inject: ['queryParams'],
  data() {
    return {
      validToken: false,
      token: '',
      full_name: '',
      date_of_birth: '',
      current_phone: '',
      previous_id: '',
      previous_legal_names: '',
      previous_phones: '',
      previous_emails: '',
      previous_addresses: '',
      degrees: '',
    }
  },
  mounted: async function() {
    console.log(this.queryParams);
    this.token = this.queryParams.get('token');
    console.log(this.token);

    await this.validateToken();
  },
  components: {
    ValidatedTextField,
  },
  methods: {
    foipAdditionalUses() {
      return "It may also be used to update your alumni record."
    },
    async validateToken() {
      console.log("validateToken " + this.token);
      this.validToken = await axios.get('/alumniccid/validatetoken', { params: { "token": this.token }})
        .then(() => true)
        .catch(() => false);
    },
    async validateFields() {
      return await this.$refs.full_name.validate()
        && await this.$refs.current_phone.validate()
        && await this.$refs.previous_legal_names.validate()
        && await this.$refs.previous_phones.validate()
        && await this.$refs.previous_emails.validate()
        && await this.$refs.previous_addresses.validate()
        && await this.$refs.degrees.validate()
    },
    async submit() {
      if (!await this.validateFields()) return;

      window.scrollTo(0,0);

      return await axios.post('/alumniccid/request', {
        token: this.token,
        full_name: this.full_name,
        date_of_birth: this.date_of_birth,
        degrees: this.degrees,
        previous_id: this.previous_id,
        current_phone: this.current_phone,
        previous_legal_names: this.previous_legal_names,
        previous_phones: this.previous_phones,
        previous_emails: this.previous_emails,
        previous_addresses: this.previous_addresses,
      })
      .then(() => {
        this.showMessage(this.$t('FORM_SUBMITTED'));
      })
      .catch((error) => {
        this.showError(error, this.$t('FORM_FAILED'));
      })
    },
  },
}
</script>
